import { call, put } from "redux-saga/effects";

import { topicsApiSlice } from "api/topicsApi.slice";
import { apiFetch } from "common/utilities";
import { RequestError } from "common/utilities/requestError";
import { openMapInvitationFailure, openMapInvitationSuccess } from "domains/createShareSettings/actions";
import type { OpenMapInvitationDefaultAction } from "domains/createShareSettings/actionTypes";
import type { TopicAccessInviteTokenResponse } from "domains/topicshare/topicshare.types";
import { store } from "store";

export function* openLinkInvitationSaga(action: OpenMapInvitationDefaultAction) {
  try {
    const invite_token = action.meta.token;
    const response: TopicAccessInviteTokenResponse = yield apiFetch(`topic/access/${invite_token}`);
    yield put(openMapInvitationSuccess(response));
    yield call(() =>
      store.dispatch(topicsApiSlice.endpoints.getTopicMetadata.initiate(undefined, { forceRefetch: true })),
    );
  } catch (error) {
    if (error instanceof RequestError)
      yield put(openMapInvitationFailure({ errorStatus: error.status }, { logoutOnAuthError: true }));
  }
}
